export enum DataType {
    Unknown = 0,
    Boolean = 1,
    Number = 2,
    Text = 3,
    DateTime = 4,
    Image = 5,
    Money = 6,
    IntegerNumber = 7,
    ShortDate = 8,
    CodeList = 9,
    Html = 10,
    Location = 11,
    Categories = 12,
    Media = 13,
    Survey = 14,
    FixedEnum = 15,
    DateRange = 16,
    NumberRange = 17,
    LocalizedTexts = 18,
    Dimensions = 19,
    ArrayOfStrings = 20,
    ArrayOfNumbers = 22,
    ArrayOfDates = 23,
    MulticurrencyPrice = 24,
    LocalizationKey = 25,
    StringDictionary = 26,
    NutsRegion = 27,
    Link = 28,
    Receipt = 29,
    LongText = 30,
    VoucherTemplate = 31,
    ProductFilterAttributes = 32,
    JsonObject = 33,
    ProductNumber = 34,
    MultiLang = 35,
    Multiselect = 36
}

export enum WalletTemplateDataSource {
    None = 0,
    Media = 1,
    PrimaryContact = 2,
    UserAttributes = 3,
    UserCard = 4,
    Voucher = 5,
    VoucherTemplate = 6,
    VoucherAttributes = 7,
    UserCardAttributes = 8,
    User = 9,
    UserRewards = 10
}

export enum WalletAppleField {
    Undefined = 0,
    LogoText = 1,
    Header = 2,
    Primary = 3,
    Secondary = 4,
    Auxiliary = 5,
    Back = 6,
    BackgroundColor = 7,
    LabelColor = 8,
    ForegroundColor = 9,
    BarcodeValue = 10,
    LogoImage = 11,
    IconImage = 12,
    ThumbnailImage = 13,
    StripImage = 14
}

export enum WalletGoogleField {
    Undefined = 0,
    IssuerName = 1,
    ProgramName = 2,
    LoyaltyPoints = 3,
    SecondaryLoyaltyPoints = 4,
    TopRowSubheader = 5,
    TopRowHeader = 6,
    
    AccountName = 7,
    AccountId = 8,

    RewardsTierLabel = 9,
    RewardsTier = 10,
    TextModulesData = 11,
    Messages = 12,
    PinLabel = 13,
    Pin = 14,
    BalanceUpdateTime = 15,
    Details = 16,
    FinePrint = 17,
    ValidTimeInterval = 18,
    Provider = 19,
    HexBackgroundColor = 20,
    /* Obsolete  */
    HexFontColor = 21,
    BarcodeValue = 22,
    HeroImage = 23,
    LogoImage = 24,

    Row1Left = 25,
    Row1Middle = 26,
    Row1Right = 27,

    Row2Left = 28,
    Row2Middle = 29,
    Row2Right = 30,

    Row3Left = 31,
    Row3Middle = 32,
    Row3Right = 33,

    LocalizedTitle = 34 // Offer only
}
